module.exports = __webpack_public_path__ + "static/media/marca-apuestas.b146b1f0.png";